function LiteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M20.0054 32.5168C24.6355 31.5896 30.6225 28.2584 30.6225 19.6453C30.6225 11.8084 24.8859 6.58872 20.7608 4.19069C19.8439 3.65746 18.773 4.35806 18.773 5.4171V8.12471C18.773 10.2606 17.8754 14.159 15.3811 15.7809C14.1073 16.6089 12.7298 15.3692 12.5758 13.8584L12.4484 12.6171C12.3003 11.1745 10.8309 10.2991 9.67857 11.1789C7.60639 12.7564 5.44238 15.5262 5.44238 19.6439C5.44238 30.1766 13.2764 32.8116 17.1926 32.8116C17.4217 32.8116 17.6607 32.8042 17.9095 32.7894C18.5701 32.7064 17.9095 32.936 20.0054 32.5153"
          fill="url(#paint0_linear_1065_4289)"
        />
        <path
          d="M20.0054 32.5168C24.6355 31.5896 30.6225 28.2584 30.6225 19.6453C30.6225 11.8084 24.8859 6.58872 20.7608 4.19069C19.8439 3.65746 18.773 4.35806 18.773 5.4171V8.12471C18.773 10.2606 17.8754 14.159 15.3811 15.7809C14.1073 16.6089 12.7298 15.3692 12.5758 13.8584L12.4484 12.6171C12.3003 11.1745 10.8309 10.2991 9.67857 11.1789C7.60639 12.7564 5.44238 15.5262 5.44238 19.6439C5.44238 30.1766 13.2764 32.8116 17.1926 32.8116C17.4217 32.8116 17.6607 32.8042 17.9095 32.7894C18.5701 32.7064 17.9095 32.936 20.0054 32.5153"
          fill="black"
          fill-opacity="0.2"
        />
      </g>
      <path
        d="M12.8477 27.5447C12.8477 31.4254 15.9744 32.6251 17.9089 32.791C18.5695 32.7081 17.9089 32.9377 20.0047 32.517C21.5437 31.9734 23.2159 30.5781 23.2159 27.5447C23.2159 25.6236 22.0028 24.4371 21.0534 23.8817C20.7631 23.7114 20.4254 23.9261 20.4002 24.2609C20.3173 25.3244 19.2952 26.1716 18.6006 25.3629C17.9859 24.649 17.7267 23.6047 17.7267 22.9367V22.0628C17.7267 21.5385 17.1979 21.1889 16.7446 21.4585C15.062 22.4553 12.8477 24.5082 12.8477 27.5447Z"
        fill="url(#paint1_linear_1065_4289)"
      />
      <path
        d="M12.8477 27.5447C12.8477 31.4254 15.9744 32.6251 17.9089 32.791C18.5695 32.7081 17.9089 32.9377 20.0047 32.517C21.5437 31.9734 23.2159 30.5781 23.2159 27.5447C23.2159 25.6236 22.0028 24.4371 21.0534 23.8817C20.7631 23.7114 20.4254 23.9261 20.4002 24.2609C20.3173 25.3244 19.2952 26.1716 18.6006 25.3629C17.9859 24.649 17.7267 23.6047 17.7267 22.9367V22.0628C17.7267 21.5385 17.1979 21.1889 16.7446 21.4585C15.062 22.4553 12.8477 24.5082 12.8477 27.5447Z"
        fill="black"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1065_4289"
          x1="5.44238"
          y1="-5.25054"
          x2="36.5493"
          y2="-1.2866"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1065_4289"
          x1="12.8477"
          y1="17.6927"
          x2="25.6405"
          y2="19.3849"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default LiteIcon;
